 if (window.screen.width > 480){

        $(document).ready(function() {
            var slides = $('.cardPictureSwitching-pc-slide.cardPictureSwitching-slide');
            var sliderContainer = $('.slider-container');
            var cardPictureSwitchingCurrentIndex = 0; // 从第0张图片开始
            var slideWidth = $('.cardPictureSwitching-slide.cardPictureSwitching-pc-slide').width();
            var sliderCount = slides.length;
            var count = Math.ceil(sliderCount - 3);


            function showSlide(index) {
                slides.removeClass('active');
                slides.eq(index).addClass('active');
            }



            function moveNext() {

                if (cardPictureSwitchingCurrentIndex < count ) {
                    cardPictureSwitchingCurrentIndex++;
                    var viewportWidth = $(window).width();
                    var oneVw = viewportWidth * 0.022;
                    slideWidth = $('.cardPictureSwitching-slide').outerWidth(true);
                    sliderContainer.animate({left: -cardPictureSwitchingCurrentIndex * (slideWidth + oneVw)}, (slideWidth ), function() {});
                    showSlide(cardPictureSwitchingCurrentIndex);
                }
            }

            function movePrevious() {
                if (cardPictureSwitchingCurrentIndex > 0) {
                    cardPictureSwitchingCurrentIndex--;
                    var viewportWidth = $(window).width();
                    var oneVw = viewportWidth * 0.022;
                    slideWidth = $('.cardPictureSwitching-slide').outerWidth(true);
                    sliderContainer.animate({left: -cardPictureSwitchingCurrentIndex * (slideWidth + oneVw)}, (slideWidth), function() {});
                    showSlide(cardPictureSwitchingCurrentIndex);
                }
            }

            var arrowRight = $('.cardPictureSwitching-arrow.arrow-right');
            var arrowLeft = $('.cardPictureSwitching-arrow.arrow-left');
            var allDiv = $('.allDiv');

            // 鼠标进入图片滑块区域时显示箭头
            allDiv.on('mouseenter', function() {
                arrowRight.css("display","flex");
                arrowLeft.css("display","flex");
            });

            // 鼠标离开图片滑块区域时隐藏箭头
            allDiv.on('mouseleave', function() {
                arrowRight.css("display","none");
                arrowLeft.css("display","none");
            });

            arrowRight.on('click', moveNext);
            arrowLeft.on('click', movePrevious);

            showSlide(cardPictureSwitchingCurrentIndex);
        });
    }

